export default __webpack_public_path__ + "static/857-6b936b9d226234a67c980a9ce35cc9a8.gif";